export const ContentListingType = {
  STATIC: 'Static',
  INTERACTIVE: 'Interactive',
};

export const ListingItemType = {
  FILE: 'File',
  LINK: 'Link',
  FOLDER: 'Folder',
  QUIZ: 'Quiz',
  EXAM: 'Exam',
  EMBEDDED: 'Html/Embedded',
};

export const QuizFeedbackMode = {
  NONE: 'None',
  INDICATE_CORRECTNESS: 'IndicateCorrectness',
  SHOW_CORRECT_ANSWERS: 'ShowCorrectAnswers',
};